<template>
  <div style="min-height: 92vh">
    <h3>Recetas AYB</h3>
    <v-row>
      <v-col cols="12" md="2"> Filtros: </v-col>
      <v-col cols="12" md="10">
        <v-autocomplete class="mt-n4" v-model="filterDepto" label="Departamento"
          :items="[{ value: 'ALL', text: 'TODOS' }, ...modulos]">
        </v-autocomplete>
      </v-col>
    </v-row>
    <v-switch v-if="$store.getters.getFirebaseApp.tenant == 'BOKA'" v-model="onlyWeb" label="Solo visibles en web">
    </v-switch>
    <uv-data-table ref="dataTable" :config="config" :data="global_prod" :pageRows="15" @buttonClick="dtButtonClick"
      @buttonOptClick="optButtonClick"></uv-data-table>
    <modal v-model="showModal" :fullscreen="true" :showFooter="false" title="Receta">
      <ProductosForm :costos="costos" :edit="editMode" :key="formIndex" @toggle="toggleModal" :dataEdit="editData"
        @successData="successData">
      </ProductosForm>
    </modal>
    <modal v-model="showModalModificador" :showFooter="false" title="Modificadores Productos">
      <ProductosModificadores :edit="editMode" :key="formIndex" @toggle="showModalModificador = false"
        :dataEdit="editData" @successData="saveModificadores" />
    </modal>
    <modal v-model="showModalPrecio" :showFooter="false" title="Modificar Precios">
      <ProductoPrecioForm :edit="editMode" :key="formIndex" @toggle="showModalPrecio = false" :dataEdit="editData">
      </ProductoPrecioForm>
    </modal>
    <modal v-model="showModalPrecioPorcentaje" :showFooter="false" title="Modificar Precios">
      <ProductoPrecioProcentajeForm :edit="editMode" :key="formIndex" @toggle="showModalPrecioPorcentaje = false"
        :dataEdit="editData">
      </ProductoPrecioProcentajeForm>
    </modal>
    <modal v-model="showModalExport" :showFooter="false" title="Exportar a excel"><v-row>
        <v-col cols="12" md="12" class="mb-n6">
          <h3>Seleccione un departamento</h3>
          <v-autocomplete @input="genDataExcel()" v-model="selectedDpto" label="Departamento" :items="modulos">
          </v-autocomplete>
        </v-col>
        <v-col cols="8" md="8" class="mb-n6"> </v-col>
        <v-col cols="4" md="4" class="text-right">
          <v-btn v-if="dataExcel.length > 0" color="green" dark
            @click="exportProductosExcel"><v-icon>mdi-file-excel-box</v-icon>
            Generar Excel
            <!-- <download-excel
              type="xls"
              name="Recetas - Productos AYB"
              :data="dataExcel"
            >
            </download-excel> -->
          </v-btn>
        </v-col>
      </v-row>
    </modal>
    <modal v-model="showModalRecetario" :showFooter="false" title="Exportar recetario"><v-row>
        <v-col cols="12" md="12" class="mb-n6">
          <h3>Seleccione un departamento</h3>
          <v-autocomplete v-model="selectedDpto" label="Departamento" :items="modulos">
          </v-autocomplete>
          <h3>Seleccione una categoria para generar</h3>

          <v-autocomplete v-model="selectedCat" multiple label="Categoria" @change="handleSelectChange"
            :items="CategoriesList" item-value="id" item-text="Nombre">
          </v-autocomplete>

          <!-- <h3>Exportar recetario a excel</h3>
          <v-switch v-model="excelSwitch">Exportar a excel</v-switch> -->
        </v-col>
        <v-col cols="8" md="8" class="mb-n6"> </v-col>
        <v-col cols="4" md="4" class="text-right">
          <v-btn v-if="selectedDpto" @click="genRecetario()" color="red" dark>
            Generar Recetario
          </v-btn>
        </v-col>
      </v-row>
    </modal>
    <replicador-recetas-masivo-modal
      :key="'modal_rep_' + (modalReplicarIndex || 0)"
      v-model="showModalReplicarMasivo"
      :mode="modalReplicarMode"
      :recetas="recetasSeleccionadasParaReplicar"
      :categories="Categories"
      :modulos="modulos"
      :origenes="global_origen"
      @success="onReplicacionExitosa"
    />
  </div>
</template>

<style scoped>
::v-deep .action-buttons-group .action-btn:has(.lni-reply) {
  margin-left: 16px !important;
  position: relative;
}
::v-deep .action-buttons-group .action-btn:has(.lni-reply)::before {
  content: "";
  position: absolute;
  left: -9px;
  top: 15%;
  height: 70%;
  width: 1px;
  background-color: rgba(0, 0, 0, 0.18);
}
</style>

<script>
import modal from "../../MainComponents/modal.vue";
import uvDataTable from "../../MainComponents/DataTable.vue";
import ProductosForm from "./ProductosAYBForm.vue";
import ProductoPrecioForm from "../../Inventarios/Productos/ProductoPrecioForm.vue";
import ProductoPrecioProcentajeForm from "../../Inventarios/Productos/ProductoPrecioPorcentajeForm.vue";
import ProductosModificadores from "../../Inventarios/Productos/ProductosModificadores.vue";
import ReplicadorRecetasMasivoModal from "./ReplicadorRecetasMasivoModal.vue";
import pdfmake from "pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { mapActions } from "vuex";
pdfmake.vfs = pdfFonts.pdfMake.vfs;
import ReporteRecetas from "../../../clases/PdfMakers/Recetario.js";
import moment from "moment";

import ProductosAYBExcel from "../../../clases/ExcelMaker/ProductosAYBExcel.js";
import ProdRecetarioAYBExcel from "../../../clases/ExcelMaker/ProdRecetarioAYBExcel.js";

export default {
  name: "ProductosCRUD",
  components: {
    modal,
    uvDataTable,
    ProductosForm,
    ProductoPrecioForm,
    ProductoPrecioProcentajeForm,
    ProductosModificadores,
    ReplicadorRecetasMasivoModal,
  },
  props: [],
  data() {
    return {
      filterDepto: "ALL",
      onlyWeb: false,
      recetaNameReply: "",
      dataExcel: [],
      selectedDpto: null,
      selectedCat: ["ALL"],
      MainDepartamento: "",
      self: this,
      showModal: false,
      formKey: 0,
      formIndex: 0,
      editMode: false,
      familias: [],
      Categories: [],
      editData: [],
      products: [],
      costos: {},
      dataToReplay: {},
      showModalReplicar: false,
      showModalReplicarMasivo: false,
      modalReplicarIndex: 0,
      modalReplicarMode: "replicate",
      recetasSeleccionadasParaReplicar: [],
      showModalPrecio: false,
      showModalModificador: false,
      showModalPrecioPorcentaje: false,
      showModalRecetas: false,
      showModalExport: false,
      showModalRecetario: false,
      zonas: [],
      config: {
        selectableRow: false,
        orderByCol: { Field: "", Type: "Asc" },
        selectConfig: {
          idRowData: "id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        buttons: [
          {
            text: "Agregar",
            icon: "lni lni-plus",
            buttonId: "addProducto",
          },
          {
            text: "Editar",
            icon: "lni lni-pencil-alt",
            buttonId: "editProducto",
            require: true,
            limitRequire: 1,
          },
          {
            text: "Eliminar",
            icon: "lni lni-trash",
            buttonId: "deleteProducto",
            require: true,
            limitRequire: 1,
          },
          /*{
            text: "Modificar Precio",
            icon: "lni lni-dollar",
            buttonId: "editPrecio",
            require: true,
          },
          {
            text: "+/- % Precio",
            icon: "",
            buttonId: "editPrecioMasivo",
            require: false,
          },*/
          {
            text: "Admin. Modificadores",
            icon: "lni lni-list",
            buttonId: "adminModificadores",
            require: true,
            limitRequire: 1,
          },
          {
            text: "Exportar a Excel",
            icon: "lni lni-database",
            buttonId: "exportExcel",
            require: false,
          },
          {
            text: "Recetario PDF",
            icon: "lni lni-files",
            buttonId: "exportRecetarioPDF",
            require: false,
          },
          {
            text: "Recetario Excel",
            icon: "lni lni-grid",
            buttonId: "exportRecetarioExcel",
            require: false,
          },
          {
            text: "Replicar Receta",
            icon: "lni lni-reply",
            buttonId: "replicarReceta",
            require: true,
            color: "primary",
          },
          {
            text: "Editar Recetas Masivo",
            icon: "lni lni-pencil-alt",
            buttonId: "editRecetasMasivo",
            require: true,
            color: "teal darken-1",
            show: false,
          },
          /*{
            text: "Recalcular costos",
            icon: "lni lni-calculator",
            buttonId: "recostear",
            require: true,
          },*/
          /* {
            text: "Admin. Receta",
            icon: "lni lni-list",
            buttonId: "adminIngredientes",
            require: true,
          },*/
        ],
        fields: [
          {
            text: "Nombre",
            value: "Nombre",
          },
          {
            text: "Codigo",
            value: "Codigo",
            format: (row) => {
              return row["Codigo"] + " " + row.id;
            }
          },
          {
            text: "Tipo",
            value: "Tipo",
            canBeFiltered: true,
          },
          {
            text: "Categoria",
            value: "categoria_name",
            canBeFiltered: true,
          },
          {
            text: "Familia",
            value: "Familia",
          },

          {
            text: "Etiquetas",
            value: "tags",
          },
          {
            text: "Departamentos",
            value: "Departamentos",
            canBeFiltered: true,
          },
          {
            text: "Costo",
            value: "Costeo",
            format: (row) => {
              let html = "";
              if (row["Costeo"]) {
                html = '<div class="cost-display-container d-flex flex-column">';
                row["Costeo"].forEach((element) => {
                  html += `
                    <div class="cost-item d-flex align-center justify-space-between mb-1 px-2 py-1" style="background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 6px; min-width: 140px;">
                      <span class="depto-label font-weight-bold text-caption text-uppercase" style="color: #64748b;">${element.depto}</span>
                      <span class="cost-value font-weight-black text-body-2 ml-4" style="color: #1e293b;">
                        ${this.$pgsHelper.formatNumber(element.uct.C)} <small class="text-caption" style="color: #64748b; font-weight: 600;">${element.uct.M}</small>
                      </span>
                    </div>
                  `;
                });
                html += '</div>';
              }

              return html;
              //return '$'+row['Precio']+' '+row['Moneda']+'';
            },
          },
          {
            text: "Precio",
            value: "PrecioSort",
            format: (row) => {
              return `
                <div class="d-flex align-center font-weight-black" style="color: #1a56db; font-size: 0.95rem;">
                  <span class="mr-1" style="opacity: 0.7;">$</span>
                  <span>${this.$pgsHelper.formatNumber(row["Precio"])}</span>
                  <small class="ml-1 text-caption font-weight-bold" style="color: #64748b; letter-spacing: 0.5px;">${row["Moneda"]}</small>
                </div>
              `;
            },
          },
        ],
      },
      excelSwitch: false,
    };
  },
  methods: {
    exportProductosExcel() {
      ProductosAYBExcel.generateExcelBuffer(this.dataExcel)
        .then((buffer) => {
          const blob = new Blob([buffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = `Recetas - Productos AYB.xlsx`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch((err) => {
          console.error("Error exportando a Excel:", err);
        });
    },
    handleSelectChange() {
      if (
        this.selectedCat.includes("ALL") &&
        this.selectedCat.some((item) => item !== "ALL")
      ) {
        // Si "ALL" está seleccionado junto con otros, elimina "ALL" y deja los otros
        let lengthSelected = this.selectedCat.length;
        if (this.selectedCat[lengthSelected - 1] == "ALL") {
          this.selectedCat = ["ALL"];
        } else {
          this.selectedCat = this.selectedCat.filter((item) => item !== "ALL");
        }
      }
    },
    dtButtonClick(buttonId, idSelected) {
      if (buttonId == "addProducto") {
        this.formIndex++;
        this.editMode = false;
        this.editData = {};
        this.$pgsHelper.log(this.editData);
        this.showModal = true;
      }
      if (buttonId == "editProducto") {
        const ids = Array.isArray(idSelected) ? idSelected : [idSelected];
        if (ids.length >= 2) {
          this.abrirEdicionMasiva(ids);
          return;
        }
        this.formIndex++;
        this.editMode = true;
        this.editData = this.getProductoById(ids[0]);
        this.$pgsHelper.log(this.editData);
        this.showModal = true;
      }
      if (buttonId == "editRecetasMasivo") {
        const ids = Array.isArray(idSelected) ? idSelected : [idSelected];
        this.abrirEdicionMasiva(ids);
      }
      if (buttonId == "costear") {
        idSelected[0];
        let datos = {
          idReceta: idSelected[0],
          porciones: 1,
          producto: this.getProductoById(idSelected[0]),
        };
        this.$alert.alertConfirm({
          action: "costear",
          obj: "la receta",
          route: "AYB-Costeo-costearReceta",
          data: datos,
          onSuccess: (data) => { },
        });
      }
      if (buttonId == "editPrecio") {
        this.formIndex++;
        this.editMode = true;
        this.editData = this.getProductoById(idSelected[0]);
        this.showModalPrecio = true;
      }
      if (buttonId == "deleteProducto") {
        this.deleteProducto(idSelected[0]);
      }
      if (buttonId == "editPrecioMasivo") {
        this.formIndex++;
        this.editMode = false;
        this.editData = {};
        this.showModalPrecioPorcentaje = true;
      }
      if (buttonId == "adminModificadores") {
        this.formIndex++;
        this.editMode = true;
        this.editData = this.$pgsHelper.getById(
          this.global_prod,
          "id",
          idSelected[0]
        );
        this.showModalModificador = true;
      }
      if (buttonId == "adminIngredientes") {
        this.formIndex++;
        this.editMode = true;
        this.editData = this.$pgsHelper.getById(
          this.global_prod,
          "id",
          idSelected[0]
        );
        this.showModalRecetas = true;
      }
      if (buttonId == "exportExcel") {
        this.showModalExport = true;
      }
      if (buttonId == "exportRecetarioPDF") {
        this.excelSwitch = false;
        this.showModalRecetario = true;
      }
      if (buttonId == "exportRecetarioExcel") {
        this.excelSwitch = true;
        this.showModalRecetario = true;
      }
      if (buttonId == "replicarReceta") {
        const ids = Array.isArray(idSelected) ? idSelected : [idSelected];
        const seleccionados = ids
          .map((id) => this.getProductoById(id))
          .filter(Boolean);

        if (seleccionados.length === 0) {
          this.$swal(
            "Seleccione un registro para continuar con la acción",
            "Antes de continuar selecciona al menos una receta haciendo click sobre ella en la tabla",
            "warning"
          );
          return;
        }

        this.modalReplicarIndex = (this.modalReplicarIndex || 0) + 1;
        this.modalReplicarMode = "replicate";
        this.recetasSeleccionadasParaReplicar = seleccionados;
        this.showModalReplicarMasivo = true;
      }
    },
    abrirEdicionMasiva(ids) {
      const idsArr = Array.isArray(ids) ? ids : [ids];
      const seleccionados = idsArr
        .map((id) => this.getProductoById(id))
        .filter(Boolean);

      if (seleccionados.length === 0) {
        this.$swal(
          "Seleccione un registro para continuar con la acción",
          "Antes de continuar selecciona las recetas haciendo click sobre ellas en la tabla",
          "warning"
        );
        return;
      }

      this.modalReplicarIndex = (this.modalReplicarIndex || 0) + 1;
      this.modalReplicarMode = "edit";
      this.recetasSeleccionadasParaReplicar = seleccionados;
      this.showModalReplicarMasivo = true;
    },
    genDataExcel() {
      let prod = this.$store.getters.getProductos;
      let productos = [];
      prod.forEach((element) => {
        if (element.Tipo == "AYB-Producto" && !element.Dlat) {
          if (element?.Departamentos.includes(this.selectedDpto)) {
            element.categoria_name = this.getCategoryById(
              element.Categoria
            ).Nombre;
            let Familia = this.getCategoryById(element.Categoria)
              ? this.getCategoryById(element.Categoria).Familia
              : "";
            element.Familia = this.$pgsHelper.getById(
              this.familias,
              "id",
              Familia
            )
              ? this.$pgsHelper.getById(this.familias, "id", Familia).Nombre
              : "";
            element.Costeo = this.costos[element.id];
            let Costo = 0;
            let CostoMoneda = "";
            if (element.Costeo) {
              let costeDepto = this.$pgsHelper.getById(
                element.Costeo,
                "depto",
                this.selectedDpto
              );
              if (costeDepto) {
                Costo = costeDepto.uct.C;
                CostoMoneda = costeDepto.uct.M;
              }
            }
            element.Catalogo.forEach((insumo) => {
              let insumoData = this.$pgsHelper.getById(prod, "id", insumo.Id);
              productos.push({
                Codigo: element.Codigo,
                RecetaId: element.id,
                Receta: element.Nombre,
                InsumoID: insumo.Id,
                Insumo: insumoData ? insumoData.Nombre : "",
                Departamento: this.selectedDpto,
                Categoria: element.categoria_name,
                Familia: element.Familia,
                Etiquetas: element.tags,
                Costo: Number(this.$pgsHelper.roundDecimals(Costo)),
                MonedaCosto: CostoMoneda,
                Precio: Number(this.$pgsHelper.roundDecimals(element.Precio)),
                Moneda: element.Moneda,
              });
            });
          }
        }
        //element.Orden = (element.Orden)?element.Orden:0;
      });

      let orderedProds = this.$_.orderBy(productos, "Categoria", "asc");

      this.dataExcel = orderedProds;
    },
    onReplicacionExitosa() {
      this.showModalReplicarMasivo = false;
      this.getCostos();
      this.recetasSeleccionadasParaReplicar = [];
      if (this.$refs.dataTable) {
        this.$refs.dataTable.selectedRow = [];
      }
    },
    optButtonClick(buttonId, ref) {
      if (buttonId == "editPrice") {
        this.editedHotel = this.getHotelinfoById(ref);
        this.toggleModal(true);
      }
    },
    successData(data, doAction) {
      data.Precio = parseFloat(data.Precio);
      data.Orden = Number(data.Orden);
      if (doAction == "CREATE") {
        this.addProduct(data);
      } else if (doAction == "EDIT") {
        this.editProduct(data);
      }
    },
    genRecetario() {
      let prod = this.$store.getters.getProductos;
      let productos = [];
      prod.forEach((element) => {
        let prodCopy = this.$pgsHelper.cloneObj(element);
        if (prodCopy.Tipo == "AYB-Producto" && !prodCopy.Dlat) {
          if (prodCopy?.Departamentos.includes(this.selectedDpto)) {
            if (
              this.selectedCat.includes(prodCopy.Categoria) ||
              this.selectedCat.includes("ALL")
            ) {
              /*if(prodCopy.CCs){
                if(prodCopy.CCs[0][this.selectedDpto][0] != "-NTTx2yfPNM81JCu4e1g"){
                  return false
                }
              }*/
              prodCopy.categoria_name = this.getCategoryById(
                prodCopy.Categoria
              ).Nombre;
              let Familia = this.getCategoryById(prodCopy.Categoria)
                ? this.getCategoryById(prodCopy.Categoria).Familia
                : "";
              prodCopy.Familia = this.$pgsHelper.getById(
                this.familias,
                "id",
                Familia
              )
                ? this.$pgsHelper.getById(this.familias, "id", Familia).Nombre
                : "";
              prodCopy.Costeo = this.costos[prodCopy.id];
              let Costo = 0;
              let CostoMoneda = "";
              if (prodCopy.Costeo) {
                let costeDepto = this.$pgsHelper.getById(
                  prodCopy.Costeo,
                  "depto",
                  this.selectedDpto
                );
                if (costeDepto) {
                  Costo = costeDepto.uct.C;
                  CostoMoneda = costeDepto.uct.M;
                }
              }
              prodCopy.Catalogo.forEach((insumo) => {
                let producto = this.$pgsHelper.getById(prod, "id", insumo.Id);
                insumo.Nombre = producto.Nombre;
                insumo.UM = insumo.Extra.AYB.UM;
                insumo.Mm = insumo.Extra.AYB.Mm;
                let costoInsumo = this.costos[insumo.Id];
                if (costoInsumo) {
                  let costeDeptoInsumo = this.$pgsHelper.getById(
                    costoInsumo,
                    "depto",
                    this.selectedDpto
                  );
                  if (costeDeptoInsumo) {
                    let CostoInsm = costeDeptoInsumo.uct.C;
                    let CostoMonedaInsm = costeDeptoInsumo.uct.M;
                    console.log("CostoInsm", CostoInsm);
                    console.log("CostoMonedaInsm", CostoMonedaInsm);
                    insumo.Costo = Number(CostoInsm);
                    console.log("insumo.Costo", insumo.Costo);
                    insumo.MonedaCosto = CostoMonedaInsm;
                  } else {
                    insumo.Costo = 0;
                    insumo.MonedaCosto = "";
                  }
                } else {
                  insumo.Costo = 0;
                  insumo.MonedaCosto = "";
                }
              });
              productos.push({
                ...prodCopy,
                Codigo: prodCopy.Codigo,
                Receta: prodCopy.Nombre,
                Departamento: this.selectedDpto,
                CategoriaId: prodCopy.Categoria,
                CategoriaNombre: prodCopy.categoria_name,
                Familia: prodCopy.Familia,
                Costo: this.$pgsHelper.formatNumber(Costo),
                MonedaCosto: CostoMoneda,
                Precio: this.$pgsHelper.formatNumber(prodCopy.Precio),
                Moneda: prodCopy.Moneda,
              });
            }
          }
        }
      });

      let orderedProds = this.$_.orderBy(
        productos,
        ["CategoriaNombre", "Receta"],
        ["asc", "asc"]
      );

      let tenant = this.$store.getters.getFirebaseApp.tenant;
      let CategoriasName = [];
      this.selectedCat.forEach((cat) => {
        CategoriasName.push(
          this.$pgsHelper.getById(this.Categories, "id", cat).Nombre
        );
      });
      let mainData = {
        FG: new moment().format("DD/MM/YYYY"),
        HG: new moment().format("HH:mm:ss"),
        TITLE: "RECETAS",
        Departamento: this.selectedCat,
        Productos: orderedProds,
        CateName: CategoriasName.join(" - "),
      };

      if (this.selectedCat.includes("ALL")) {
        mainData.CateName = "Todos";
      }
      if (this.excelSwitch) {
        this.exportExcelRecetario(mainData)
      } else {
        let docData = ReporteRecetas.getDocData(mainData);
        pdfmake.createPdf(docData).open();
      }
    },
    async deleteProducto(id) {
      const deletedObject = this.getProductoById(id) || { Id: id };
      let datos = { Id: id };
      this.$alert.alertConfirm({
        action: "eliminar",
        obj: "el producto",
        route: "PDV-Productos-deleteProducto",
        data: datos,
        onSuccess: () => {
          this.getCategories();
          this.$pgsHelper.writeLog({
            Evento: "PRODUCTO_DELETE",
            Mensaje: "Producto eliminado ",
            reference: { id: id, tp: "AYB-Producto", al: "RECETA AYB" },
            data: deletedObject
          });
        },
      });
    },
    async exportExcelRecetario(data) {
      try {
        const buffer = await ProdRecetarioAYBExcel.generateExcelBuffer(data);
        const blob = new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "Recetario.xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Error exportando Excel:", error);
      }
    },
    editProduct(datos) {
      //datos.Departamento      =  this.MainDepartamento;
      this.$alert.alertConfirm({
        action: "editar",
        obj: "el producto",
        route: "PDV-Productos-updateProducto",
        data: datos,
        onSuccess: () => {
          this.$pgsHelper.writeLog({
            Evento: "PRODUCTO_EDIT",
            Mensaje: "Producto editado",
            reference: { id: datos.id, tp: "AYB-Producto", al: "RECETA AYB" },
            data: datos
          });
          this.toggleModal(false);
        },
      });
    },
    addProduct(datos) {
      this.$alert.alertConfirm({
        action: "crear",
        obj: "el producto",
        route: "PDV-Productos-createProducto",
        data: datos,
        onSuccess: () => {
          this.toggleModal(false);
          this.showModalReplicar = false;
          this.$pgsHelper.writeLog({
            Evento: "PRODUCTO_CREATE",
            Mensaje: "Producto creado",
            reference: { id: datos.id, tp: "AYB-Producto", al: "RECETA AYB" },
            data: datos
          });
        },
      });
    },
    saveModificadores(datos) {
      this.$alert.alertConfirm({
        action: "actualizar",
        obj: "los modificadores del producto",
        route: "PDV-Productos-updateProducto",
        data: datos,
        onSuccess: () => {
          this.$pgsHelper.writeLog({
            Evento: "PRODUCTO_MODIFICADOR_EDIT",
            Mensaje: "Modificadores del producto editados",
            reference: { id: datos.id, tp: "AYB-Producto", al: "RECETA AYB" },
            data: datos
          });
          this.showModalModificador = false;
        },
      });
    },
    toggleModal(open) {
      this.showModal = open;
    },
    async getZonasImpresion() {
      const snapshot =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "/PDV/ZonasImpresion"
        );
      if (snapshot.exists()) {
        this.zonas = [];
        this.zonas.push({ Id: "TICKET-PRINTER", nomb: "Default" });
        Object.keys(snapshot.val()).forEach((id) => {
          const toAdd = snapshot.val()[id];
          if (toAdd) {
            toAdd.Id = id;
            this.zonas.push(toAdd);
          }
        });
      }
    },
    ...mapActions("Categorias", { fetchCategories: "getCategories" }),
    async getCategories() {
      this.Categories = await this.fetchCategories();
    },
    getCategoryById(code) {
      let itemIndex = this.$_.findIndex(this.Categories, { id: code });
      if (itemIndex >= 0) {
        return this.Categories[itemIndex];
      }

      return false;
    },
    getProductoById(code) {
      let itemIndex = this.$_.findIndex(this.global_prod, { id: code });
      if (itemIndex >= 0) {
        return this.$pgsHelper.cloneObj(this.global_prod[itemIndex]);
      }

      return false;
    },
    async getCostos() {
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      const data = await firestore.queryBuilder("PDV_Costos", [
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
      ]);
      let costos = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });
      let globalCosto = {};
      costos.forEach((element) => {
        let prod = Object.entries(element.pds);
        prod.forEach((pd) => {
          if (!globalCosto[pd[0]]) {
            globalCosto[pd[0]] = [];
            globalCosto[pd[0]].push({ depto: element.dpt, ...pd[1] });
          } else {
            globalCosto[pd[0]].push({ depto: element.dpt, ...pd[1] });
          }
        });
      });
      this.costos = globalCosto;
    },
    async getProducts() { },
    async getFamilias() {
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/Productos/Familias"
        );

      this.familias = [];
      this.familias = this.$pgsHelper.ArrayObjectToArray(data.val());
    },
  },
  computed: {
    categoriesList() {
      let categories = [];
      if (this.productoData.Departamentos.length > 0) {
        this.Categories.forEach((categoria) => {
          this.productoData.Departamentos.forEach((modulo) => {
            if (modulo == categoria.Departamento) {
              categories.push(categoria);
            }
          });
        });
        return categories;
      } else {
        return this.Categories;
      }
    },
    CategoriesList() {
      let data = [{ id: "ALL", Nombre: "TODOS" }];
      this.Categories.forEach((cate) => {
        data.push(cate);
      });
      return data;
    },
    modulos() {
      let dep = [
        /*{ value: "", text: "Seleccione un modulo" }*/
      ];
      let departamentos = this.$store.getters.getPDVDepartamentos;
      departamentos.forEach((element) => {
        dep.push({ value: element.id, text: element.Nombre });
      });
      return dep;
    },
    global_origen() {
      return this.$store.getters.getCentrosConsumo || [];
    },

    global_prod() {
      let prod = this.$store.getters.getProductos;
      let origenes = this.$store.getters.getOrigenes;
      let productos = [];
      prod.forEach((element) => {
        element.categoria_name = this.getCategoryById(element.Categoria).Nombre;
        if (this.getCategoryById(element.Categoria).ZImp) {
          element.ZImp = this.$pgsHelper.getById(
            this.zonas,
            "Id",
            this.getCategoryById(element.Categoria).ZImp
          ).nomb;
        } else {
          element.Zimp = "Default";
        }
        if (element.Tipo == "AYB-Producto" && !element.Dlat) {
          let Familia = this.getCategoryById(element.Categoria)
            ? this.getCategoryById(element.Categoria).Familia
            : "";
          element.Familia = this.$pgsHelper.getById(
            this.familias,
            "id",
            Familia
          )
            ? this.$pgsHelper.getById(this.familias, "id", Familia).Nombre
            : "";
          if (this.onlyWeb) {
            if (element.dcdg) {
              productos.push(element);
            }
          } else {
            productos.push(element);
          }
        }
        //element.Orden = (element.Orden)?element.Orden:0;
      });

      productos.forEach((producto) => {
        producto.PrecioSort = parseFloat(producto.Precio) || 0;
        let invData = [];
        let matchCount = 0;
        origenes.forEach((origen, index) => {
          let origenesNames = this.$store.getters.getCentrosConsumo;
          let itemIndex = this.$_.findIndex(origenesNames, {
            id: origen.Origen,
          });
          origen.nombreOrigen = origenesNames[itemIndex]?.Nombre;
          let OrProd = Object.entries(origen.Productos);
          let productMatch = "";
          OrProd.forEach((oProducto) => {
            if (oProducto[0] == producto.id) {
              productMatch = oProducto;
              matchCount++;
              //this.$pgsHelper.log(oProducto[1]);
              /* let pro = producto;
                    let idCompuesto = pro.id+'_'+origen.Origen;
                    pro.Existencia = oProducto[1].Stock;
                    pro.compId = idCompuesto;
                    newProductos.push({id:idCompuesto ,Existencia: oProducto[1].Stock,...producto});*/
            }
          });
          if (productMatch != "") {
            invData.push({
              Origen: origen.Origen,
              Price: productMatch[1],
              Costo: this.$pgsHelper.formatNumber(
                this.costos[producto.id]?.cto?.C || 0
              ),
              NombreOrigen: origen.nombreOrigen,
            });
          }
        });

        producto.existenciaPrecio = invData;
        producto.existenciaData = invData;
        //producto.Costeo = this.costos[producto.id];
        if (this.costos[producto.id]) {
          let costosRaw = this.costos[producto.id];
          let costeoValido = [];
          costosRaw.forEach((costoDepto) => {
            let exist = this.$pgsHelper.getById(
              this.modulos,
              "value",
              costoDepto.depto
            );
            if (exist) {
              costeoValido.push(costoDepto);
            }
          });
          producto.Costeo = costeoValido;
        }
      });
      if (this.filterDepto != "ALL") {
        productos = this.$pgsHelper.filterBy(
          productos,
          "Departamentos",
          this.filterDepto,
          true
        );
      }
      let data = productos;
      /*let claims = this.$route.params.user.tokenResult.claims;
      if (claims?.Data?.Only?.AYB) {
        data = JSON.parse(JSON.stringify(productos)).filter((prod) => {
          if (prod.Departamentos && prod.Departamentos.includes('Restaurante')) {
            return true;
          } else {
            return false;
          }
        });
      }*/
      let sortReservations = this.$_.orderBy(data, "Orden", "asc");

      return sortReservations;
    },
  },
  watch: {},
  mounted() {
    this.$nextTick(() => {
      const masivoBtn = this.config.buttons.find(
        (b) => b.buttonId === "editRecetasMasivo"
      );
      if (this.$refs.dataTable && masivoBtn) {
        this.$watch(
          () => (this.$refs.dataTable.selectedRow || []).length >= 2,
          (shouldShow) => {
            masivoBtn.show = shouldShow;
          },
          { immediate: true }
        );
      }
    });
  },
  created() {
    if (this.modalReplicarIndex === undefined) { 
      this.$set(this, "modalReplicarIndex", 0);
    }
    this.MainDepartamento = localStorage.getItem("selectedDepartment");
    this.getFamilias();
    this.getCategories();
    this.getZonasImpresion();
    this.getCostos();
    //this.getProducts();
  },
};
</script>
